import { render, staticRenderFns } from "./AtcFormCloseButton.vue?vue&type=template&id=5d210b8b&scoped=true&"
import script from "./AtcFormCloseButton.vue?vue&type=script&lang=js&"
export * from "./AtcFormCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./AtcFormCloseButton.vue?vue&type=style&index=0&id=5d210b8b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d210b8b",
  null
  
)

export default component.exports